import { ReactNode } from "react";
import { PageCategory, PageHeader } from "./page-header";

interface PageProps {
  children: ReactNode;
  title?: string;
  description?: string;
  category?: PageCategory;
  parent?: {
    title: string;
    path: string;
  };
  skipHeader: boolean;
}

export function Page({ children, title, description, category, parent, skipHeader }: PageProps) {
  return (
    <div className="min-h-screen">
      {title && category && (
        <PageHeader
          title={title}
          description={description}
          category={category}
          parent={parent}
          showTitle={!skipHeader}
        />
      )}
      <div className="flex-1 space-y-4 p-8 pt-6">{children}</div>
    </div>
  );
}

export default {
  Page,
};
